import React from 'react';
import NavigationDrawer from 'src/components/Navigation/NavigationDrawer';
function NavBar({ drawerOpen, toggleDrawer, selectedNav, routesForNavigation, isManagerMode }) {
    return (
    // @ts-ignore
    React.createElement(NavigationDrawer, { open: drawerOpen, routes: routesForNavigation, onOpenDrawer: () => toggleDrawer(true), onCloseDrawer: () => toggleDrawer(false), selectedNav: selectedNav, isManagerMode: isManagerMode }));
}
export default NavBar;
